import { Layers } from "./map/layers";

export enum CustomerStatus {
    Current = "current",
    FrankfordTarget = "frankford target",
    PriorityA = "priority a",
    PriorityB = "priority b",
    Lost = "lost"
}

export enum CustomerType {
    Customer = "customer",
    Contract = "contract dealer",
    BeachConcession = "beach concession",
    Designer = "designer"
}

export enum CustomerDiscounts {
    Standard = 'std',
    Reorder = 'reorder',
    EarlyBuy = 'eb'
  }

const TypeToViewMap = new Map();

TypeToViewMap.set(CustomerType.Customer, Layers.Customers);
TypeToViewMap.set(CustomerType.Designer, Layers.Customers);
TypeToViewMap.set(CustomerType.Contract, Layers.Contract);
TypeToViewMap.set(CustomerType.BeachConcession, Layers.Beach);


export default TypeToViewMap;
